import React from 'react';
import classNames from 'classnames';

import { isValidEmail, passwordErrors } from 'helpers/Account';
import FacebookLinking from '../AccountComponents/FacebookLinking';

import Style from '../AccountComponents/FacebookLinking/FacebookLinking.module.scss';

export function setFacebookLinkingErrors(cb, name) {
  const { facebookLinkingPassword, facebookLinkingEmail } = this.state;
  const facebookLinkingPasswordError = passwordErrors(facebookLinkingPassword);
  const facebookLinkingEmailError = !isValidEmail(facebookLinkingEmail);
  const setStateCb = () => {
    const { facebookLinkingPasswordError, facebookLinkingEmailError } = this.state;
    const hasErrors = facebookLinkingPasswordError || facebookLinkingEmailError || false;
    if (cb) return cb(hasErrors);
    return hasErrors;
  };
  if (name) {
    switch (name) {
      case 'facebookLinkingPassword':
        this.setState({ facebookLinkingPasswordError }, setStateCb);
        break;
      case 'facebookLinkingEmail':
        this.setState({ facebookLinkingEmailError }, setStateCb);
        break;
      default:
        break;
    }
  } else {
    return this.setState(
      {
        facebookLinkingPasswordError,
        facebookLinkingEmailError,
      },
      setStateCb,
    );
  }
  return null;
}

export function renderFacebookLinking() {
  const { backgroundClass, language } = this.props;
  const {
    facebookLinkingEmail,
    facebookLinkingEmailError,
    facebookLinkingGenericError,
    facebookLinkingPassword,
    facebookLinkingPasswordError,
    facebookLinkingShowPassword,
    showFacebookLinking,
  } = this.state;
  const {
    profileSignin_forgotPasswordText: linkText,
    profile_facebookExistingLinkHeader: headerText,
  } = language || {};
  const headerProps = {
    headerText,
    hideCloseButton: true,
    onClose: this.onClose,
    renderLogo: this.renderLogo,
  };
  const forgotPasswordCTAProps = {
    containerClass: classNames(
      Style.signInForgotPasswordContainer,
      Style.facebookLinkingForgotPasswordContainer,
    ),
    linkClass: classNames(
      Style.signInForgotPassword,
      Style.link,
      Style.facebookLinkingForgotPassword,
    ),
    linkText,
    onClick: () => {
      this.toggleFacebookLinking();
      if (this.onForgotPasswordClick) this.onForgotPasswordClick();
    },
  };
  const facebookLinkingProps = {
    backgroundClass,
    facebookLinkingEmail,
    facebookLinkingEmailError,
    facebookLinkingGenericError,
    facebookLinkingPassword,
    facebookLinkingPasswordError,
    facebookLinkingShowPassword,
    forgotPasswordCTAProps,
    headerProps,
    language,
    onFieldChange: this.onFieldChange,
    onLinkFacebook: this.onLinkFacebook,
  };
  if (!showFacebookLinking) return null;
  return <FacebookLinking {...facebookLinkingProps} />;
}
